<template>
    <div id="app" class="antialiased leading-normal" style="background: #fafafa">
    
    <div class="flex flex-col">
        <c-nav class="fixed inset-x-0 top-0 z-10"/>

        <div class="flex flex-col min-h-screen pt-16 sm:pt-32">
            <router-view class="relative"></router-view>
            <c-footer />
        </div>
    </div>
        <div v-if="!$root.isProduction" class="fixed bottom-0 left-0 right-0 z-50 w-full px-5 py-2 text-sm text-center text-black" style="background: rgba(237, 137, 54, 0.6)">Environnement de test</div>
    </div>
</template>

<script>
import CNav from '@/components/layout/Nav'
import CFooter from '@/components/layout/Footer'

export default {
  name: 'app',
  components: { CNav, CFooter }
}
</script>

<style src="./assets/css/tailwind.css" />
